<template>
    <nav v-if="$root.isLoggedIn()" class="left-navbar col-3">
        <div class="d-flex flex-column h-100">

            <div class="container-header nav-brand sticky-top">
                <div class="p-2 brand-logo"></div>
                <div class="pl-2 pb-1 pt-1 nav-brand-organisation">
                    <span v-text='$root.user ? $root.user.provider.name : ""'></span>
                    <span v-text='isServiceAvailable() ? "" : "(Offline)"'></span>
                </div>
            </div>

            <div class='pt-2 h-100 flex-grow-1-scroll'>
                
                <ul v-if='$root.user && $root.user.id' class="list-group">
                    <li class='nav'>
                        <router-link to="/home">
                            <i class="icon icon-home"></i>
                            <span>{{ $t('translations.home')}}</span>
                        </router-link>
                    </li>
                    <li class='nav'>
                        <router-link to="/news-list">
                            <i class="icon icon-md icon-news"></i>
                            <span>{{ $t('translations.news')}}</span>
                        </router-link>
                    </li>
                    <li class='nav-separator'>&nbsp;</li>
                    <li class='nav'>
                        <router-link to="/provider-list">
                            <i class="icon icon-md icon-provider"></i>
                            <span>{{ $t('translations.providers')}}</span>
                        </router-link>
                    </li>
                    <li class='nav'>
                        <router-link to="/staff-list">
                            <i class="icon icon-md icon-staff"></i>
                            <span>{{ $t('translations.staff')}}</span>
                        </router-link>
                    </li>

                    <li class='nav'>
                        <router-link to="/restrictedPatientSearch">
                            <i class="icon icon-md icon-patients"></i>
                            <span>{{ autobrand('translations.restricted_patient_search')}}</span>
                        </router-link>
                    </li>
                    <li class='nav'>
                        <router-link to="/presetmessage-list">
                            <i class="icon icon-md icon-preset-message-white"></i>
                            <span>{{ $t('translations.preset_messages')}}</span>
                        </router-link>
                    </li>
                    
                    <li class='nav'  data-navname='forms' v-on:click.stop="setActiveNav" :class="'nav ' + isActive('forms')">
                        <router-link to="/form-list" tag="a" class="nav">
                            <i class="icon icon-md icon-form"></i>
                            <span>{{ $t('translations.forms') }}</span>
                            <span class="icon-arrow-down icon-small"></span>
                        </router-link>
                        <ul v-on:click.stop>
                            <router-link to="/code-helper" tag="li" class="nav">
                                <a>
                                    <i class="icon icon-md icon-code"></i>
                                    <span>{{ $t('translations.codes') | capitalise }}</span>
                                </a>
                            </router-link>
                        </ul>
                    </li>
                    <li class='nav-separator'>&nbsp;</li>
                </ul>
                <div class='m-2'>
                    <label for="select-provider" class="sr-only">Select Provider</label>
                    <select v-model='admin_provider_id'  class="form-control">
                        <option v-for="provider in sortByValue($root.lookup.providers)" :value="provider.id" :key="provider.id">{{provider.name}}</option>
                    </select>
                </div>
                <ul v-if='$root.user && $root.user.id' class="list-group">
                    <li class='nav'>
                        <router-link to="/dashboard">
                            <i class="icon icon-dashboard"></i>
                            <span>{{ $t('translations.dashboard')}}</span>
                        </router-link>
                    </li>
                     
                    
                    <li data-navname='profile' v-on:click.stop="toggleActiveNav" :class="'nav ' + isActive('profile')">
                        <a >
                            <i class="icon icon-settings"></i>
                            <span>{{ $t('translations.settings') }}</span>
                            <span class="icon-arrow-down icon-small"></span>
                        </a>
                        <ul v-on:click.stop>
                            <router-link to="/usergroup-list" tag="li" class="nav">
                                <a>
                                    <i class="icon icon-md icon-groups"></i>
                                    <span>{{ $t('translations.groups') }}</span>
                                </a>
                            </router-link>
                            <router-link to="/settings" tag="li" class="nav">
                                <a>
                                    <i class="icon icon-md icon-provider"></i>
                                    <span>{{ $t('translations.system') }}</span>
                                </a>
                            </router-link>
                        </ul>

                    </li>
                    <router-link to="/reports" tag="li" class="nav">
                        <a>
                            <i class="icon icon-md icon-reports"></i>
                            <span>{{ $t('translations.reports')}}</span>
                        </a>
                    </router-link>
                    <router-link to="/feedback-list" tag="li" class="nav">
                        <a>
                            <i class="icon icon-md icon-feedback-patient"></i>
                            <span>{{ autobrand('translations.patient_feedback')}}</span>
                        </a>
                    </router-link>
                    <!-- <li class='nav-separator'>&nbsp;</li>
                    <li data-navname='feedback' v-on:click.stop="toggleActiveNav" :class="'nav ' + isActive('feedback')">
                        <a >
                            <i class="icon icon-feedback"></i>
                            <span>{{ $t('translations.feedback')}}</span>
                            <span class="icon-arrow-down icon-small"></span>
                        </a>
                        <ul v-on:click.stop>
                             <li class="nav">
                                <a :href="'https://askmygp.formstack.com/forms/askmygp_user_report?name='+this.$root.user.forenames+'%20'+this.$root.user.surname+'&email='+this.$root.user.email+'&organisation='+this.$root.user.provider.name" target="_blank">
                                    <i class="icon icon-md icon-feedback-send"></i>
                                    <span>{{ $t('translations.send_feedback')}}</span>
                                </a>
                             </li>
                             <router-link to="/feedback-list" tag="li" class="nav">
                                <a>
                                    <i class="icon icon-md icon-feedback-patient"></i>
                                    <span>{{ autobrand('translations.patient_feedback')}}</span>
                                </a>
                            </router-link>
                        </ul>
                    </li> -->
                    <li class='nav-separator'>&nbsp;</li>
                    <router-link to="/network-settings" tag="li" class="nav">
                        <a>
                            <i class="icon icon-md icon-settings"></i>
                            <span>{{ $t('translations.network_settings')}}</span>
                        </a>
                    </router-link>
                </ul>
                
            </div>
            <div class="container-footer nav-brand text-center mt-auto d-flex flex-column p-2">

                <div>
                    <div class="helpdesk-widget"  v-on:click.prevent='$root.freshdeskShowWidget()'>Help</div>
                </div>
                <!-- <div class="locale-changer d-flex col-12">
                    <select v-model="locale" v-on:change="setLocale" class="form-control form-control-sm">
                        <option v-for="(lang, key) in langs" :value="lang" placeholder="select lang">{{ lang }}</option>
                    </select>
                </div> -->
                <span class="p-2">{{formatName(this.$root.user)}}</span>
                <template v-if="$root.isLoggedIn()">
                    <div>
                        <a href="/logout" class="btn btn-light btn-round text-center">{{ $t('translations.logout') }}</a>
                    </div>
                </template>
            </div>
        </div>
    </nav>

</template>

<script>
export default {
    props: {
        
    },
    data: function(){
        return {
            subNavActive: undefined,
            helpLinks: {'dashboard': 'dashboard'},
            currentHelpLink: "",
        };
    },
    computed: {
        admin_provider_id: {
            get: function() {
                return this.$root.admin_provider_id;
            },
            set: function(value) {
                this.$root.admin_provider_id = value;
                this.setSetting('admin_provider_id', this.$root.admin_provider_id);
            }
        }
    },
    methods: {
        isActive(name) {
            return this.subNavActive == name ? "active" : "";
        },
        toggleActiveNav(event) {
            if(event.currentTarget.dataset["navname"]) {
                this.subNavActive === event.currentTarget.dataset["navname"] ? this.subNavActive = null : this.subNavActive = event.currentTarget.dataset["navname"];
            }
            else {
                this.subNavActive = null;
            }
        },
        setActiveNav(event) {
            this.subNavActive = event.currentTarget.dataset["navname"];
        },
        // getHelpLink() {
        //     var parts = this.$route.path.split("/");
        //
        //     while(parts.length > 1 && parts[parts.length - 1].match(/[0-9]/)) {
        //         parts.pop();
        //     }
        //
        //     if(parts.length > 1
        //          // && this.helpLinks[parts[parts.length - 1]]
        //          ) {
        //         //return "https://askmygp.nickelled.com/" + this.helpLinks[parts[parts.length - 1]];
        //         return "https://askmygp.nickelled.com/" + parts[parts.length - 1];
        //     }
        //     return false;
        // },
        // showNoHelp() {
        //     this.$modal.show('dialog', {
        //         title: 'Help',
        //         text: "No help available for this page.",
        //         buttons: [
        //         {
        //             title: 'Close',
        //             default: true
        //         }]});
        // }

    }
}
</script>
